// CRM Upgrade v2 · Stage & VIP utility helpers.
// Stage è derivato da orders_count (non persistito). VIP effettivo combina
// vip_manual + soglia €2000.

export const VIP_THRESHOLD_CENTS = 200000; // €2000

export function getCustomerStage(ordersCount) {
  const n = Number(ordersCount || 0);
  if (n <= 0) return null;
  if (n === 1) return "seed";
  if (n === 2) return "plant";
  if (n === 3) return "tree";
  return "fire";
}

export const STAGE_ICON = {
  seed:  "🌱",
  plant: "🌿",
  tree:  "🌳",
  fire:  "🔥",
};

export const STAGE_LABEL = {
  seed:  "Seme",
  plant: "Piantina",
  tree:  "Albero",
  fire:  "Fiamma",
};

export function isVipEffective(customer) {
  if (!customer) return false;
  if (customer.vip_effective !== undefined) return !!customer.vip_effective;
  const manual = !!customer.vip_manual;
  const spent = Number(customer.total_spent_cents || 0);
  return manual || spent >= VIP_THRESHOLD_CENTS;
}

export function vipReason(customer) {
  const manual = !!customer?.vip_manual;
  const auto = Number(customer?.total_spent_cents || 0) >= VIP_THRESHOLD_CENTS;
  if (manual && auto) return "VIP manuale + automatico (spesa ≥ 2.000 €)";
  if (manual) return "VIP manuale";
  if (auto) return "VIP automatico · spesa totale ≥ 2.000 €";
  return null;
}

export function marketingStateLabel(state) {
  return {
    accepted: "Accettato",
    rejected: "Rifiutato",
    never:    "Mai espresso",
  }[state] || "—";
}

export function marketingStateStyle(state) {
  return {
    accepted: "bg-emerald-100 text-emerald-900 border-emerald-300",
    rejected: "bg-red-100 text-red-900 border-red-300",
    never:    "bg-sand-100 text-ink-700 border-sand-300",
  }[state] || "bg-sand-100 text-ink-700 border-sand-300";
}
